import { creatorbase, creatorbaseQueries, queryHelpers } from '@round/api';
import { useQueryClient } from '@tanstack/react-query';
import useProjectId from './useProjectId';

export default function useInvalidateProjectCampaigns() {
    const queryClient = useQueryClient();
    const projectId = useProjectId();

    return (platform: creatorbase.Platform) => {
        if (typeof projectId !== 'number') {
            return Promise.resolve();
        }

        return queryClient.invalidateQueries({
            queryKey: creatorbaseQueries.campaigns.keys.lists(),
            predicate: (query) => {
                const { params } = queryHelpers.parseQueryKey(
                    query.queryKey as queryHelpers.QueryKey<creatorbase.GetCampaignsParams>
                );
                return params?.project_id === projectId && params?.platform === platform;
            },
        });
    };
}
